import { css } from '@linaria/core';
import { FC } from 'react';
export const TypingIndicator: FC = () => {
  return <div className={dotLoader}>
      <div className={dot} />
      <div className={dot} />
      <div className={dot} />
    </div>;
};
const dotLoader = "odules__Playground__Components__TypingIndicator_tsx-dotLoader-dpmzftp";
const dot = "odules__Playground__Components__TypingIndicator_tsx-dot-dxwrhjq";

require("./TypingIndicator.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TypingIndicator.tsx");